module.exports = __webpack_public_path__ + "static/media/blog_home.d4185b80.png";